import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoint from '@utils/useBreakpoint';
const SelectorPopup = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    const selectorRef = useRef(null);
    const buttonRef = useRef(null);
    const menuRef = useRef(null);
    const [open, setOpen] = useState(false);
    const currentBreakpoint = useBreakpoint();
    useEffect(() => {
        const selectorButton = buttonRef.current;
        const setButtonWidth = () => {
            if (selectorButton && props.enableOnlyOneLeftLabel) {
                if (currentBreakpoint < window.mqObj.sm) {
                    selectorButton.classList.add('selector__button__mobile');
                    const viewportWidth = window.innerWidth;
                    const dynamicWidth = `${viewportWidth * 0.35 + 15}px`; // Calcola la larghezza dinamica in base alla viewport
                    selectorButton.style.width = dynamicWidth;
                }
                else {
                    selectorButton.classList.remove('selector__button__mobile');
                    // Resetta la larghezza
                    selectorButton.style.width = '';
                }
            }
        };
        // Esegue la funzione quando la finestra viene ridimensionata
        window.addEventListener('resize', setButtonWidth);
        setButtonWidth();
        // Rimuove il listener quando il componente viene smontato
        return () => {
            window.removeEventListener('resize', setButtonWidth);
        };
    }, [currentBreakpoint]);
    useEffect(() => {
        var _a, _b;
        if (open) {
            props.trackOpen ? props.trackOpen() : null;
            (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            (_b = selectorRef.current) === null || _b === void 0 ? void 0 : _b.removeAttribute('style');
        }
    }, [open]);
    useEffect(() => {
        setOpen(props.open);
    }, [props.open, props.currentItem]);
    const enableOutofstockClass = useMemo(() => {
        var _a;
        let enabled = false;
        if (props.enableOutofstockLabel && !props.swatchable && !((_a = props.currentItem) === null || _a === void 0 ? void 0 : _a.selectable)) {
            enabled = true;
        }
        if (props.stockStatus) {
            if (props.stockStatus === 'PRODUCT__OOS' || props.stockStatus === 'SIZE__OOS') {
                enabled = true;
            }
        }
        return enabled;
    }, [props.enableOutofstockLabel, props.swatchable, props.currentItem, props.stockStatus]);
    // if there is the selector button info
    const selectorBtnInfo = (props.enableOnlyOneLeftLabel) || (props.enableOutofstockLabel && !props.swatchable && !((_a = props.currentItem) === null || _a === void 0 ? void 0 : _a.selectable));
    return (React.createElement("div", { className: classNames(props.className), ref: selectorRef },
        React.createElement("button", { type: "button", ref: buttonRef, "aria-controls": props.selectorId, onClick: () => {
                setOpen(!open);
                props.onClickExtraAction && props.onClickExtraAction(true);
            }, className: classNames('selector__button', { 'with-btn-info': selectorBtnInfo }) }, props.currentItem ? (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "selector__button__label" }, props.selectedLabel + ' '),
            !props.hideValue && (React.createElement("span", { className: classNames('selector__button__value', enableOutofstockClass && 'selector__button__value--outofstock') }, props.itemType === 'string' ? props.currentItem : (_b = props.currentItem) === null || _b === void 0 ? void 0 : _b.displayValue)),
            React.createElement("span", { className: "visually-hidden" }, t('exchanges.changecolor')),
            props.enableOutofstockLabel && !props.swatchable && !props.currentItem.selectable && React.createElement("span", { className: "selector__button__info" }, t('label.outofstock')),
            props.enableOnlyOneLeftLabel && React.createElement("span", { className: "selector__button__info" }, t('bag.onlyoneleft')))) : (React.createElement(React.Fragment, null,
            React.createElement("span", null, (props === null || props === void 0 ? void 0 : props.hideUnselectedLabel) ? props.selectedLabel : props === null || props === void 0 ? void 0 : props.unselectedLabel),
            (props === null || props === void 0 ? void 0 : props.hideUnselectedLabel) && props.stockStatus === 'PRODUCT__OOS' && !props.swatchable && (React.createElement("span", { className: "selector__button__info outofstock--all" }, t('label.outofstock'))),
            React.createElement(AnimatePresence, null, props.error && (React.createElement(motion.span, { className: "errormessage", transition: { ease: [0.25, 1, 0.5, 1], duration: 0.166 }, initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, role: "alert" }, props.error))))))));
};
SelectorPopup.defaultProps = {
    swatchable: false,
    enableOutofstockLabel: false,
    hideValue: false,
    itemType: 'object',
};
export default SelectorPopup;
